// --------------------------------------------------------------------------
// #26 – COMPARE OPTIONS
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var expandedHeight = context.find('.promo-code input').outerHeight();

    function init() {

        function triggerMembershipSubmit() {
            var compareMembershipInputs = $(context).find('input');
            compareMembershipInputs.keyup(function (e) {
                if (e.which === 13) {
                    $(this).closest('[data-binding="compare-membership-details"]').find('[data-binding="choose-membership"]').trigger('click');
                }
            });
        }

        function openPromoBox(trigger) {
            var promoCodeContent = trigger.siblings('[data-binding="promo-content"]');
            promoCodeContent.animate({ 'height': expandedHeight }, function () {
                promoCodeContent.css('height', 'auto');
            });
        }

        /**
         * Show promo code input on compare membership module
         */
        context.on({
            click: function click(e) {
                e.preventDefault();
                if (!context.hasClass('isVisible')) {
                    openPromoBox($(this));
                }
            },
            focus: function focus() {
                openPromoBox($(this));
            }
        }, '[data-binding="show-promo"]');

        //Add accessible display
        context.on({
            focus: function focus() {
                $(this).addClass('focus');
                triggerMembershipSubmit();
            },
            blur: function blur() {
                $(this).removeClass('focus');
            }
        }, '.compare-membership-option');
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/compare-membership.js
// module id = 188
// module chunks = 0